document.addEventListener('DOMContentLoaded', function() {
    const copyButtons = document.querySelectorAll('.gh-copy-link');
    
    copyButtons.forEach(button => {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            const url = this.dataset.url;
            
            navigator.clipboard.writeText(url).then(() => {
                const originalText = this.textContent;
                this.textContent = 'Copied!';
                
                setTimeout(() => {
                    this.innerHTML = `{{> "icons/link"}}Copy link`;
                }, 2000);
            });
        });
    });
});